/**
 * Renders the saved items on the /pages/favoritos page from localStorage
 * (see wishlist.js). Clones a server-rendered <template> so markup — and
 * the <favorite-button> custom element inside it — stays in sync with the
 * rest of the site automatically.
 */
(function () {
  function fillCard(node, item) {
    var favoriteButton = node.querySelector('favorite-button');
    if (favoriteButton) {
      favoriteButton.dataset.productId = item.id || '';
      favoriteButton.dataset.productHandle = item.handle || '';
      favoriteButton.dataset.productTitle = item.title || '';
      favoriteButton.dataset.productImage = item.image || '';
      favoriteButton.dataset.productPrice = item.price || '';
      favoriteButton.dataset.productUrl = item.url || '';
    }

    var link = node.querySelector('.favorites-grid__link');
    if (link) link.setAttribute('href', item.url || '#');

    var image = node.querySelector('.favorites-grid__image');
    if (image) {
      if (item.image) {
        image.src = item.image;
        image.alt = item.title || '';
      } else {
        image.remove();
      }
    }

    var titleLink = node.querySelector('.favorites-grid__title');
    if (titleLink) {
      titleLink.textContent = item.title || '';
      titleLink.setAttribute('href', item.url || '#');
    }

    var price = node.querySelector('.favorites-grid__price');
    if (price) price.textContent = item.price || '';
  }

  function render() {
    var grid = document.getElementById('favorites-grid');
    var empty = document.getElementById('favorites-empty');
    var template = document.getElementById('favorites-card-template');
    if (!grid || !empty || !template || !window.MexiaWishlist) return;

    var items = window.MexiaWishlist.read();
    grid.innerHTML = '';

    if (items.length === 0) {
      grid.hidden = true;
      empty.hidden = false;
      return;
    }

    empty.hidden = true;
    grid.hidden = false;

    items.forEach(function (item) {
      var node = template.content.cloneNode(true);
      fillCard(node, item);
      grid.appendChild(node);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }
  document.addEventListener('wishlist:change', render);

  // Re-render whenever this page becomes visible again, including when the
  // browser restores it from bfcache after navigating back from a product
  // page — otherwise it can show stale favorites until a manual refresh.
  window.addEventListener('pageshow', render);
})();
